// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const icon = "Icon__icon__BJWj0";
export const innerSvg = "Icon__innerSvg__puP+o";
export const rotating = "Icon__rotating__Olbdg";
export const rotation = "Icon__rotation__WhW9L";
export const playable = "Icon__playable__twHUF";
export const play = "Icon__play__nGK2R";
export const lastFrame = "Icon__lastFrame__EBLAw";